// extracted by mini-css-extract-plugin
module.exports = {"card":"NewsCard_card_2pJYE","heading":"NewsCard_heading_1yPds"};